import { Box, Grid, Stack, Typography } from '@mui/material';

import type { ReactNode } from "react";

export type CatalogGroupProps = {
    title: string;
    /** A short count next to the heading, e.g. "4 workouts". */
    count?: string;
    children?: ReactNode;
};

/** One heading of the catalogue with the cards below it; the cards are Grid items of its container. */
export function CatalogGroup({ title, count, children }: CatalogGroupProps) {
    return <Box component="section">
        <Stack direction="row" alignItems="baseline" spacing={ 1.25 } sx={ { mb: 2 } }>
            <Typography component="h2" variant="inherit" sx={ { fontSize: 20, lineHeight: '28px', fontWeight: 800 } }>{ title }</Typography>
            { count && <Typography sx={ { fontSize: 13, color: '#4F5B67' } }>{ count }</Typography> }
        </Stack>

        <Grid container spacing={ 3 }>
            { children }
        </Grid>
    </Box>;
}
